import { render, staticRenderFns } from "./PattyLanding.vue?vue&type=template&id=615ad5a5&"
import script from "./PattyLanding.vue?vue&type=script&lang=js&"
export * from "./PattyLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports